const gsapTitle = gsap => {
  const title = document.querySelectorAll('.title-h2');
  title.forEach(item => {
    gsap.from(item, {
      x: 100,
      y: 20,
      ease: 'back.out(1.7)',
      opacity: 0,
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        once: true,
      },
    });
  });
};
export default gsapTitle;
